import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { ScreenSequence } from "../Sequences";
import { FramingScreen1 } from "./FramingScreen1";
import { FramingScreen2Config } from "./FramingScreen2";
import { FramingScreen3Config } from "./FramingScreen3";
import { ResultScreen } from "./ResultScreen";
import { ResultScreenGlobal } from "./ResultScreenGlobal";
import { ExplanationScreenRiskyChoice } from "./ExplanationScreen";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { experiments } from "../../../../translations/experiments";

// Export this constant for use in the Sequences.tsx file
export const RiskyChoiceFramingKey = "RiskyChoiceFraming";

/**
 * Hook to get the Risky Choice Framing experiment sequence with translations
 * Uses the language context to provide translated content
 */
export function useRiskyChoiceFramingSequence(): ScreenSequence {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { userData } = useSession();
    const { t } = useLanguage();

    return {
        name: t('experiments', 'RiskyChoiceFraming', 'title'),
        description: t('experiments', 'RiskyChoiceFraming', 'description'),
        group: "A1",
        screens: [
            { component: FramingScreen1 },
            { component: FramingScreen2Config.component },
            { component: FramingScreen3Config.component },
            { component: ResultScreen.component },
            { component: ResultScreenGlobal.component },
            { component: ExplanationScreenRiskyChoice.component },
            {
                component: WellDoneScreen,
                canContinueDefault: false,  // Nur hier!
            }
        ],
        resultScreenIndex: 3,
        explanationScreenIndex: 5,
    };
}

// Get the current locale's translations for static use
const riskyChoiceFramingTranslations = experiments.RiskyChoiceFraming.de;

// Export the static sequence for use in Sequences.tsx
export const RiskyChoiceFramingSequence: ScreenSequence = {
    name: riskyChoiceFramingTranslations.title,
    description: riskyChoiceFramingTranslations.description,
    group: "A1",
    screens: [
        { component: FramingScreen1 },
        { component: FramingScreen2Config.component },
        { component: FramingScreen3Config.component },
        { component: ResultScreen.component },
        { component: ResultScreenGlobal.component },
        { component: ExplanationScreenRiskyChoice.component },
        {
            component: WellDoneScreen,
            canContinueDefault: false,  // Nur hier!
        }
    ],
    resultScreenIndex: 4,
    explanationScreenIndex: 6,
};